import React from 'react';
import { HeartIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="py-20 md:py-32 relative overflow-hidden" data-id="element-167">
      <div className="absolute inset-0 bg-gradient-to-b from-purple-900/90 to-indigo-900/90" data-id="element-168"></div>
      {/* Main meditation image */}
      <div className="absolute inset-0 z-0" data-id="element-169">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cE53FkXWqXHcsoyBhZFfv8/Generated_Image_September_13%2C_2025_-_2_01AM_%281%29.png" alt="Programa de Meditación Guiada 30 Días" className="w-full h-full object-cover opacity-90" data-id="element-170" />
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-171">
        <div className="max-w-3xl mx-auto text-center mt-24 md:mt-0" data-id="element-172">
          <div className="bg-purple-900/60 backdrop-blur-md p-6 md:p-8 rounded-2xl shadow-lg mb-10 text-white mt-16 md:mt-8" data-id="element-173">
            <p className="text-lg md:text-xl text-purple-200 italic" data-id="element-174">
              Algo dentro de ti te trajo hasta aquí
            </p>
            <p className="mt-4 text-purple-100" data-id="element-175">
              No es casualidad que estés leyendo estas palabras. Es el momento
              de dejar atrás la mente inquieta y volver a tu centro.
            </p>
            <p className="mt-4 text-purple-100" data-id="element-176">
              Este reto de 30 días no es teoría. Es una experiencia real que
              sentirás desde el primer día.
            </p>
          </div>
          <a href="#pricing" className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center mx-auto inline-flex" data-id="element-177">
            <HeartIcon size={20} className="mr-2" data-id="element-178" />
            Comenzar Mi Transformación
          </a>
        </div>
      </div>
    </section>;
}